import { Color4 } from "@babylonjs/core";
import { useTheme } from "@mui/material";
import * as React from "react";

import type { BabylonTheme } from "./state.ts";

/**
 * The Babylon clear colour matching the app's current light/dark mode.
 *
 * Babylon takes a `Color4`, not a CSS value, so the colour cannot be handed to
 * it as a design token the way the rest of the app consumes colour — and it is
 * particular about the hex strings it parses (no CSS shorthand like `#FFF`).
 * The two literals below are therefore explicit, and this is the one place they
 * live so a canvas mounted outside the 3D panel cannot drift from it.
 */
export function useBabylonTheme(): BabylonTheme {
  const theme = useTheme();
  return React.useMemo(() => {
    const backgroundColor =
      theme.palette.mode === "dark"
        ? Color4.FromHexString("#323236FF")
        : Color4.FromHexString("#FFFFFFFF");
    return { backgroundColor };
  }, [theme]);
}
